import { Layout } from 'antd'
import React from 'react'
import HeaderBar from '../../components/portal/ContentHeader'
import ContentMain from '../../components/portal/ContentMain'
import FooterBar from '../../components/portal/FooterBar'

const { Header, Content, Footer } = Layout

class Index extends React.Component {
    render() {
        // 设置Sider的minHeight可以使左右自适应对齐
        const theme = 'light'
        return (
            <div id='page'>
                <Layout>
                    <Layout>
                        <Header style={{ background: '#fff', padding: '0 16px', height: '54px' }}>
                            <HeaderBar />
                        </Header>
                        <Content style={{ background: '#fff' }}>
                            <ContentMain />
                        </Content>
                        <Footer style={{ textAlign: 'center' }}>
                            <FooterBar />
                        </Footer>
                    </Layout>
                </Layout>
            </div>
        );
    }
}
export default Index